// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pagi-js": () => import("./../../../src/pages/pagi.js" /* webpackChunkName: "component---src-pages-pagi-js" */),
  "component---src-pages-sore-js": () => import("./../../../src/pages/sore.js" /* webpackChunkName: "component---src-pages-sore-js" */)
}

